import React, { useEffect, useState, useRef } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import CaptchaComponent from "../components/CaptchaComponent";
import { Link, useNavigate } from "react-router-dom";
import Modal2 from "../components/model2";
import {sendWelcomeEmailArtistReseller} from "../../utility/emailUtility";


const Signup = () => {
    const [username, setFullName] = useState("");
    const fullNameInputRef = useRef(null);
    const userTypeRef = useRef(null);
    const selectISDRef = useRef(null);
    const mobileRef = useRef(null);
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const rePasswordRef = useRef(null);
    const captchaRef = useRef(null); // Add this ref for the captcha input

    const [isChecked, setIsChecked] = useState(false);

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isValidPassword, setIsValidPassword] = useState(true);

    const [isdcodes, setISDCode] = useState([]);
    const [selectedISDCode, setSelectedISDCode] = useState('99');
    const [isdSearchTerm, setISDSearchTerm] = useState('');

    const [mobile, setMobileNumber] = useState("");
    const [isValidMobile, setIsValidMobile] = useState(true);
    const [isDuplicateMobile, setIsDuplicateMobile] = useState(false); // New state for duplicate mobile

    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isDuplicateEmail, setIsDuplicateEmail] = useState(false); // New state for duplicate email

    const [selectedUser, setSelectedUser] = useState('0');
    const [userType, setUserType] = useState(null);

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fullNameInputRef.current.focus();
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ISDCodeList', setISDCode);
    }, []);


    const handleCheck = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleFullNameChange = (event) => {
        setFullName(event.target.value);
    };


    const handlePasswordChange = (event) => {
        const newPassword = event.target.value;
        setPassword(newPassword);

        // Validate password and confirm password
        setIsValidPassword(newPassword === confirmPassword);
    };

    const handleConfirmPasswordChange = (event) => {
        const newConfirmPassword = event.target.value;
        setConfirmPassword(newConfirmPassword);

        // Validate password and confirm password
        setIsValidPassword(password === newConfirmPassword);
    };

    const handleISDCodeChange = (event) => {
        setSelectedISDCode(event.target.value);
        setMobileNumber("");
    };

    const handleMobileNumberChange = async (event) => {
        const inputMobileNumber = event.target.value;
        const maxLength = selectedISDCode === '99' ? 10 : 11;

        if (/^\d*$/.test(inputMobileNumber) && inputMobileNumber.length <= maxLength) {
            setMobileNumber(inputMobileNumber);
            setIsValidMobile(true);

            // Check for duplicate mobile number
            await checkForDuplicates(inputMobileNumber, email);

        } else {
            setIsValidMobile(false);
        }
    };

    const handleEmailChange = async (event) => {
        const inputEmail = event.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmail(inputEmail);
        setIsValidEmail(emailRegex.test(inputEmail) || inputEmail === "");

        // Check for duplicate email
        await checkForDuplicates(mobile, inputEmail);
    };

    const handleKeyPress = (event) => {
        const value = isdSearchTerm + event.key;
        setISDSearchTerm(value);

        const exactMatch = isdcodes.find(code => code.isdCode === value);
        const partialMatch = isdcodes.find(code => code.isdCode.startsWith(value) || code.isdCodeName.toLowerCase().includes(value.toLowerCase()));

        const match = exactMatch || partialMatch;

        if (match) {
            handleISDCodeChange({ target: { value: match.isdCode } });
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => setISDSearchTerm(''), 500);
        return () => clearTimeout(timeoutId);
    }, [isdSearchTerm]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        //alert(`Captcha Value: ${captchaValue}, entered captcha: ${enteredCaptcha}`);
        // Validate all fields
        if (!selectedOption) {
            alert('Please select a user type.');
            if (userTypeRef.current) {
                userTypeRef.current.focus();
            }
            return;
        }
        if (username.trim() === '') {
            alert('Please enter your full name.');
            fullNameInputRef.current.focus();
            return;
        }
        if (mobile.trim() === '') {
            alert('Please enter mobile number');
            mobileRef.current.focus();
            return;
        }
        const minLength = selectedISDCode === '99' ? 10 : 8; // Minimum length depends on ISD code
        if (mobile.length !== minLength) {
            alert('Please enter a valid mobile number with the correct number of digits.');
            mobileRef.current.focus();
            return;
        }
        if (!isValidMobile) {
            alert('Please enter a valid mobile number.');
            mobileRef.current.focus();
            return;
        }
        if (isDuplicateMobile) {
            alert("Duplicate mobile number. Please use a different one.");
            return;
        }
        if (email.trim() === '') {
            alert("Please enter a valid email address.");
            emailRef.current.focus();
            return;
        }
        if (isDuplicateEmail) {
            alert("Duplicate email found. Please use a different one.");
            return;
        }
        if (!isValidEmail) {
            alert('Please enter a valid email address.');
            emailRef.current.focus();
            return;
        }
        if (password === '') {
            alert("Please enter a password.");
            passwordRef.current.focus()
            return;
        }
        if (confirmPassword === '') {
            alert("Please enter password again.");
            rePasswordRef.current.focus()
            return;
        }
        if (password !== confirmPassword) {
            setIsValidPassword(false);
            rePasswordRef.current.focus();
            return;
        }
        // Focus on the captcha input after confirming password
        if (enteredCaptcha.trim() === '') {
            alert("Please enter the captcha.");
            if (captchaRef.current) { // Ensure captchaRef is not null before focusing
                captchaRef.current.focus();
            }
            return;
        }
        if (enteredCaptcha !== captchaValue) {
            alert("Invalid captcha");
            if (captchaRef.current) {
                captchaRef.current.value = ''; // Clear the input field if captcha is invalid
                captchaRef.current.focus();
            }
            return;
        }
        if (!isChecked) {
            alert("Please check terms and conditions");
            return;
        }
        const formData = {
            username,
            userType_id: selectedOption,
            ISDCode: selectedISDCode,
            mobile,
            email,
            password,
        };
        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Add-SaveUserDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                console.log('Form data saved successfully');

                // Send email after user is successfully saved

                // Proceed to send email
                const success = await sendWelcomeEmailArtistReseller(username, selectedISDCode, mobile, email, password);
                if (success) {
                    alert("Registered Successfully !! Please Check your Email !!");
                } else {
                    alert("Registered Successfully, but failed to send email.");
                }


                setFullName("");
                setUserType(null);
                setMobileNumber("");
                setEmail("");
                setPassword("");
                setConfirmPassword("");
                setIsValidPassword(true);
                setIsValidMobile(true);
                setIsValidEmail(true);
                fullNameInputRef.current.focus();

            } else {
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }
    };

    

    // State to track the selected radio button
    const [selectedOption, setSelectedOption] = useState(''); // Default to 'Buyer'

    // Options for the radio buttons
    const options = [
        { id: '2', label: 'Artist' },
        { id: '4', label: 'Reseller' }
    ];
    // Handle change event for radio buttons
    const onChangehandle = (event) => {
        setSelectedOption(event.target.id);
    };



    const [captchaValue, setCaptchaValue] = useState('');
    const [enteredCaptcha, setEnteredCaptcha] = useState('');

    const handleCaptchaChange = (generatedCaptcha, userInput) => {
        setCaptchaValue(generatedCaptcha); // Set the generated CAPTCHA
        setEnteredCaptcha(userInput); // Set the entered CAPTCHA
    };

    const checkForDuplicates = async (mobile, email) => {

        if (!mobile && !email) return; // Ensure values are present before checking

        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Check-CheckDuplicateMobileEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ mobile, email }),
            });

            if (response.ok) {
                const result = await response.json();
                setIsDuplicateMobile(result.isDuplicateMobile);
                setIsDuplicateEmail(result.isDuplicateEmail);
            } else {
                console.error('Error checking for duplicates:', response.statusText);
            }
        } catch (error) {
            console.error('Error checking for duplicates:', error);
        }
    };



    return (
        <>
            <Header />
            <div className="bg-light p-4" style={{ marginTop: '110px' }}>
                <div className="col-lg-5 col-md-6 col-sm-8 m-auto bg-white border">
                    <div className="box500">
                        <h5 className="">Register an Account</h5>
                        <hr className="mb-4" />
                        <form>
                            <div className="rbtn_list">
                                <span>I am (Please Select)</span>
                                {options.map((option) => (
                                    <div key={option.id}>
                                        <input
                                            type="radio"
                                            id={option.id}
                                            name="rbtn-usertype"
                                            checked={selectedOption === option.id}
                                            onChange={onChangehandle}
                                            tabIndex={1}
                                        />
                                        <label htmlFor={option.id}>{option.label}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="row_input">
                                        <span className="lbl1">Full Name</span>
                                        <input
                                            type="text"
                                            value={username}
                                            id="fullName"
                                            maxLength={35}
                                            onChange={handleFullNameChange}
                                            ref={fullNameInputRef}
                                            tabIndex={2}
                                            placeholder="Enter your full name"
                                            className="txt1"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="d-flex">
                                        <div className="row_input me-3" style={{ width: 150 }}>
                                            <span className="lbl1">ISD Code</span>

                                            <select
                                                id="selectedISDCode"
                                                ref={selectISDRef}
                                                value={selectedISDCode}
                                                name="selectedISDCode"
                                                className="txt1"
                                                onChange={handleISDCodeChange}
                                                tabIndex={3}
                                                onKeyDown={handleKeyPress}
                                            >
                                                <option value="0">--ISD--</option>
                                                {isdcodes.map((code) => (
                                                    <option key={code.isdCode} value={code.isdCode}>
                                                        {code.isdCodeName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="row_input">
                                            <span className="lbl1">Mobile Number</span>
                                            <input
                                                type="text"
                                                value={mobile}
                                                onInput={handleMobileNumberChange}
                                                id="mobileNumber"
                                                tabIndex={4}
                                                ref={mobileRef}
                                                placeholder="Enter mobile number"
                                                //className="txt1"
                                                className={`txt1 ${isValidMobile ? "" : "is-invalid"}`}
                                                autoComplete="off"
                                            />
                                        </div>
                                        {!isValidMobile && (
                                            <div className="invalid-feedback">Mobile number exceeds maximum length.</div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="row_input">
                                        <span className="lbl1">Email Address</span>
                                        <input
                                            type="text"
                                            value={email}
                                            onInput={handleEmailChange}
                                            id="email"
                                            tabIndex={5}
                                            maxLength={45}
                                            ref={emailRef}
                                            placeholder="Enter your email address"
                                            //className="txt1"
                                            className={`txt1 ${isValidEmail ? "" : "is-invalid"}`}
                                            autoComplete="off"
                                        />
                                    </div>
                                    {!isValidEmail && (
                                        <div className="invalid-feedback">Please enter a valid email address.</div>
                                    )}
                                </div>
                                <div className="col-sm-12">
                                    <div className="row_input">
                                        <span className="lbl1">Password</span>
                                        <input
                                            type="password"
                                            value={password}
                                            onInput={handlePasswordChange}
                                            id="password"
                                            tabIndex={6}
                                            maxLength={20}
                                            ref={passwordRef}
                                            placeholder="Enter Password"
                                            className="txt1"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="row_input">
                                        <span className="lbl1">Confirm Password</span>
                                        <input
                                            type="password"
                                            value={confirmPassword}
                                            onInput={handleConfirmPasswordChange}
                                            id="confirmPassword"
                                            tabIndex={7}
                                            maxLength={20}
                                            ref={rePasswordRef}
                                            placeholder="Confirm Password"
                                            //className="txt1"
                                            className={`txt1 ${isValidPassword ? "" : "is-invalid"}`}
                                            autoComplete="off"
                                        />
                                    </div>
                                    {!isValidPassword && (
                                        <div className="invalid-feedback">Passwords do not match.</div>
                                    )}
                                </div>
                                <div className="col-sm-12">
                                    <div className="row_input">
                                        <CaptchaComponent
                                            value={enteredCaptcha}
                                            ref={captchaRef}
                                            onCaptchaChange={handleCaptchaChange}
                                            tabIndex={8}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-12 mb-3">
                                    <label className="d-flex align-items-center" style={{fontSize:'14px'}}>
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={handleCheck}
                                        />&nbsp;
                                         I accept &nbsp;<Link to="/termsConditions" target="_blank">Terms and Conditions</Link>
                                    </label>
                                </div>
                            </div>
                            <div className="pb-2 text-center">
                                <button
                                    type="submit"
                                    className="btn btn-dark w-50 font-weight-bold mt-2 p-2 rounded-1"
                                    tabIndex={9}
                                    onClick={handleSubmit}
                                >Sign Up</button>
                            </div>
                            <div className="pb-2 text-center">Already Registered, <Link to={'/login'} tabIndex={10}>Login</Link></div>
                        </form>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Signup;
